import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldValue } from '../../../../../helpers/collaborativeIndexations'
import { Default } from './Default.jsx'

class Translated extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        field: PropTypes.string.isRequired,
        value: PropTypes.string,
    }

    render()
    {
        const { t, field, value } = this.props
        const translatedValue = translateFormFieldValue(t, field, value)

        return <Default field={field} value={translatedValue} />
    }
}

export default withTranslation()(Translated)
